/** Keep the short-lived access token through Safari page restores without using localStorage. */
const ACCESS_TOKEN_KEY = "nf_access_token";
let accessToken = null;
let refreshInFlight = null;

function readPersistedToken() {
  if (accessToken || typeof window === "undefined") return accessToken;
  try {
    accessToken = window.sessionStorage.getItem(ACCESS_TOKEN_KEY);
  } catch {
    accessToken = null;
  }
  return accessToken;
}

export function getStoredAccessToken() {
  return readPersistedToken();
}

export function setStoredAccessToken(token) {
  accessToken = token || null;
  try {
    if (accessToken) {
      window.sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    } else {
      window.sessionStorage.removeItem(ACCESS_TOKEN_KEY);
    }
  } catch {
    // Private browsing may deny sessionStorage; memory storage still works.
  }
}

export function clearStoredAccessToken() {
  accessToken = null;
  try {
    window.sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  } catch {
    // Ignore storage cleanup failures.
  }
}

export function getRefreshInFlight() {
  return refreshInFlight;
}

export function setRefreshInFlight(promise) {
  refreshInFlight = promise;
}

export function clearRefreshInFlight() {
  refreshInFlight = null;
}
